export enum VacationTypes {
  BULLETIN = 'ბიულეტენი',
  DAY_OFF = 'day-off',
  FAMILY_LEAVE = 'საოჯახო შვებულება',
  MATERNITY_LEAVE = 'დეკრეტული შვებულება',
  PERMISSION = 'კუთვნილი შვებულება',
  UNPAID = 'არა-ანაზღაურებადი'
}

export enum CustomTimeZones {
  ASIA_TBILISI = 'Asia/Tbilisi'
}
